export const ORDERLOCATIONS_TEMPLATE = "ORDER_LOCATIONS_TEMPLATE";
export const ORDERLOCATIONS_TEMPLATE_ADD = "ORDER_LOCATIONS_TEMPLATE_ADD";
export const ORDERLOCATIONS_TEMPLATE_DELETE = "ORDER_LOCATIONS_TEMPLATE_DELETE";
export const ORDERLOCATIONS_TEMPLATE_EDIT = "ORDER_LOCATIONS_TEMPLATE_EDIT";

export const ORDERLOCATIONS_TEMPLATE_SET_ROW_DATA =
  "ORDER_LOCATIONS_TEMPLATE_SET_ROW_DATA";
export const ORDERLOCATIONS_TEMPLATE_SET_EDIT_DATA =
  "ORDER_LOCATIONS_TEMPLATE_SET_EDIT_DATA";

export const MODEL_OPEN = "ORDER_LOCATIONS_TEMPLATE_MODEL_OPEN";
export const MODEL_CLOSE = "ORDER_LOCATIONS_TEMPLATE_MODEL_CLOSE";

export const ORDERLOCATIONS_TEMPLATE_LIST_SUCCESSFUL =
  "ORDER_LOCATIONS_TEMPLATE_LIST_SUCCESSFUL";
export const ORDERLOCATIONS_TEMPLATE_ADD_SUCCESSFUL =
  "ORDER_LOCATIONS_TEMPLATE_ADD_SUCCESSFUL";
export const ORDERLOCATIONS_TEMPLATE_EDIT_SUCCESSFUL =
  "ORDER_LOCATIONS_TEMPLATE_EDIT_SUCCESSFUL";

export const API_ERROR = "API_ERROR";
export const SET_PARAMS = "ORDER_LOCATIONS_TEMPLATE_SET_PARAMS";

export const SELECT_CHANGEVALUE = "SELECT_CHANGEVALUE";
export const INPUT_CHANGEVALUE = "INPUT_CHANGEVALUE";

export const LOCATION_IMAGE_TEMPLATE = "Location_Image_Template";
export const GET_Location_TEMPLATE_ROW_DATA = "get_Location_Template_Row_Data";
export const Location_TEMPLATE_ROW_SUCCESSFUL =
  "Location_Template_row_successfull";

export const CLEAR_ORDERLOCATION_TEMPLATE_DATA =
  "CLEAR_ORDERLOCATION_TEMPLATE_DATA";
